import type { ArtMetadata } from "../schedule-presets/art-metadata";
import type { BuilderArtwork } from "./artwork";
import type { BuilderDayLayout } from "./day-layouts";
import type { MetadataEventPayload } from "../metadata-history/metadata-events";
import { weekdayKeys } from "../schedule-time/schedule-dates";
import { artworkPlacement } from "./artwork-placement";
import { defaultElementPosition } from "../schedule-art/layout-coordinates";

export function createOfflineLayout(metadata: ArtMetadata, artwork: BuilderArtwork): MetadataEventPayload {
  const placements = artwork.offline.map(artworkPlacement);
  const anchors = Object.fromEntries(weekdayKeys.map((day, index) => [day, placements[index]!.point])) as BuilderDayLayout["anchors"];
  const layout: BuilderDayLayout = {
    mode: "offline", anchors, exceptions: {},
    // Start the shared text inside Monday's artwork, relative to its top-left anchor.
    shared: [{ bind: "offline.message", style: "builder_offline_text", offset: defaultElementPosition(placements[0]!.textOffset) }],
  };
  const style = { ...metadata.styles.offline_label, size: 48, align: "center" as const };
  return { type: "day-layout/set", layout, styles: { builder_offline_text: style }, action: "initialize" };
}
